export default "__VITE_ASSET__69ebc688__"